import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls the window to the top instantly on every route change.
// Placed inside <BrowserRouter> so it can read the current pathname.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
